const MONEY_DECIMALS = 2

export const roundMoney = (value: number): number => {
  const factor = 10 ** MONEY_DECIMALS
  return Math.round(value * factor) / factor
}

export const sanitizeMoneyText = (raw: string): string => {
  const cleaned = raw.replace(/[^0-9.]/g, '')
  const [whole, ...rest] = cleaned.split('.')
  if (rest.length === 0) return whole
  return `${whole}.${rest.join('').slice(0, MONEY_DECIMALS)}`
}

export const parseMoneyText = (text: string): number | null => {
  if (text === '' || text === '.') return null
  const parsed = Number(text)
  return Number.isFinite(parsed) ? parsed : null
}

export const formatMoneyText = (value: unknown): string => {
  if (value === '' || value === null || value === undefined) return ''
  const parsed = Number(value)
  return Number.isFinite(parsed) ? String(roundMoney(parsed)) : ''
}
